import { render, staticRenderFns } from "./CardMenuHorizontal.vue?vue&type=template&id=5ea40236&"
import script from "./CardMenuHorizontal.vue?vue&type=script&lang=js&"
export * from "./CardMenuHorizontal.vue?vue&type=script&lang=js&"
import style0 from "./CardMenuHorizontal.vue?vue&type=style&index=0&id=5ea40236&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports